import React from "react";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const LanguageButton = ({ isActive, label, onPress }) => {
  const { isRTL } = useApp();

  return (
    <div className="radio-card-container" disabled={isActive} onClick={onPress}>
      <div
        className={`radio-btn-container ${
          isActive && "active-radio-btn-container"
        }`}
      >
        {isActive && <div className="radio-btn-inner-circle"></div>}
      </div>
      <span className={isRTL ? "radio-card-label-rtl" : "radio-card-label"}>
        {label}
      </span>
    </div>
  );
};

export default LanguageButton;
